import { QueryClient, useQuery } from '@tanstack/react-query';

import { getAccount } from '../../../api/account/getAccount';
import { AccountResponse } from '../../../api/account/types';

interface UseAccountParams<T> {
  select?: (accountResponse: AccountResponse) => T;
  enabled?: boolean;
}

const ACCOUNT_STALE_TIME = 12 * 60 * 60 * 1000; // 12 hours half a day

/**
 * return the currently logged in account
 */
export function useAccount<T = AccountResponse>({
  select,
  enabled = true,
}: UseAccountParams<T> = {}) {
  return useQuery({
    queryKey: accountKeys.account,
    staleTime: ACCOUNT_STALE_TIME,
    queryFn: getAccount,
    select: select,
    enabled: enabled,
  });
}

export function fetchAccount(queryClient: QueryClient) {
  return queryClient.fetchQuery({
    queryKey: accountKeys.account,
    staleTime: ACCOUNT_STALE_TIME,
    queryFn: () => getAccount(),
  });
}

export const accountKeys = {
  account: ['account'] as const,
};

export function useVerificationStatus() {
  return useAccount({
    select: (account) => {
      return account.verificationStatus;
    },
  });
}
